<template>
	<button class="btn-send" @click="$emit('click')" :disabled="disabled">
		<svg class="btn-send__icon"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M15.5 0.5L10.25 15.5L7.25 8.75L0.5 5.75L15.5 0.5Z"
				fill="white"
				stroke="white"
				stroke-linecap="round"
				stroke-linejoin="round"/>
		</svg>
		Send
	</button>
</template>

<script>
export default {
	name:  'SendButton',
	props: {
		disabled: {
			type:    [Boolean],
			default: false
		}
	},
};
</script>
